import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

interface PortalDsCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
  id?: string;
  'aria-labelledby'?: string;
}

export function PortalDsCard({
  children,
  className,
  padding = true,
  id,
  'aria-labelledby': ariaLabelledBy,
}: PortalDsCardProps) {
  return (
    <section
      id={id}
      aria-labelledby={ariaLabelledBy}
      className={cn(portalDs.card, padding && portalDs.cardPadding, className)}
    >
      {children}
    </section>
  );
}

interface PortalDsSectionHeaderProps {
  overline?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  titleId?: string;
  className?: string;
}

export function PortalDsSectionHeader({
  overline,
  title,
  description,
  actions,
  titleId,
  className,
}: PortalDsSectionHeaderProps) {
  return (
    <div className={cn('mb-5 flex flex-wrap items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        {overline ? (
          <p className={cn(portalDs.sectionLabel, 'mb-2')}>{overline}</p>
        ) : null}
        <h2 id={titleId} className={portalDs.sectionTitle}>
          {title}
        </h2>
        {description ? (
          <p className={cn(portalDs.sectionSubtitle, 'mt-1')}>{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
